import { render } from "./Main.vue?vue&type=template&id=30e3ddc4"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
script.render = render

export default script